module.exports = __webpack_public_path__ + "assets_app/img/key_3.79cf70c1.svg";